import { Switch } from '@mui/material'
import IconTooltipButton from '../../../../../button/IconTooltipButton'
import DataGrid from '../../../../../table/DataGrid'

const YearsList = ({ list = [], isLoading, permissions, onModal }) => {
  const columnsTable = [
    {
      show: true,
      key: 'position',
      align: 'center',
      hide: false,
      width: 5,
      label: '',
      className: 'text-center'
    },
    {
      show: true,
      key: 'isHidden',
      hide: false,
      width: 2,
      label: ''
    },
    {
      show: true,
      key: 'name',
      hide: false,
      width: 300,
      label: 'Name'
    },
    {
      show: true,
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ]

  return (
    <DataGrid
      id='years-list'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      rows={list.map((row) => {
        return {
          ...row,
          isHidden: <Switch size='small' checked={row.isHidden || false} readOnly={true} />,
          position: (
            <div className='flex items-center justify-center'>
              <div className='size-8 flex items-center justify-center bg-primary text-primary-foreground rounded-full'>
                {row.position}
              </div>
            </div>
          ),
          actions: (
            <div>
              <IconTooltipButton title='Preview' icon='expand-alt' onClick={() => onModal('preview', row)} />
              {permissions['updated'] && (
                <IconTooltipButton title='Edit' icon={['fas', 'edit']} onClick={() => onModal('edit', row)} />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onModal('delete', row)}
                />
              )}
            </div>
          )
        }
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any year yet"
    />
  )
}

export default YearsList
